import React from "react";
import spin from "../../assets/icons/popup/Loading.png";

export default function Spinner({ showText = true }) {
  return (
    <div role="status" className="flex justify-center flex-col items-center">
      {/* Gradient Ring Spinner */}
      <div className="w-40 h-40 rounded-full animate-spin">
        <img src={spin} alt="spin" />
      </div>

      {showText && (
        <span className="text-white text-sm text-center font-semibold font-poppins mt-2">
          Please Wait...
        </span>
      )}
    </div>
  );
}
